import {Route, Switch} from 'react-router-dom'
import {routes} from 'src/shared/routes'

import {HomePage} from './home/ui/HomePage/ClientHomePage'

export function Routing() {
  return (
    <Switch>
      <Route path={routes.home.path}>
        <HomePage />
      </Route>
    </Switch>
  )
}
